import { FC, useState } from 'react'

import Image from 'next/image'

import QuizPopup from './QuizPopup'

import { pluralize } from '@/helpers/text.utils'
import { useGetUserByToken } from '@/helpers/useGetUserByToken'
import { useGetQuizAccessQuery, useGetQuizByWebinarIdQuery } from '@/redux/services/webinarsApi'
import classNames from 'classnames'
import s from './Quiz.module.scss'

type TQuizProps = {
    webinarId: number
}

const Quiz: FC<TQuizProps> = ({ webinarId }) => {
    const { data: quizData } = useGetQuizByWebinarIdQuery(webinarId)

    const [quizVisible, setQuizVisible] = useState(false)
    const title = `Тест по теме «${quizData?.title}»`
    const questionsCount = quizData?.questions.length
    const user = useGetUserByToken()

    const { data: accessData, isLoading } = useGetQuizAccessQuery(
        { userId: user.id, quizId: quizData?.id },
        { skip: !user.id || !quizData?.id }
    )
    const isDisable = isLoading || !accessData?.access

    const handleQuizVisible = () => {
        if (isDisable) return
        setQuizVisible(true)
    }
    const handleClose = () => setQuizVisible(false)

    return (
        <section className={s.quizBlock}>
            <div className={s.quizBlock__inner}>
                <div className={s.quizBlock__content}>
                    <p className={classNames('categories-slider__text', s.quizBlock__preTitle)}>Тест</p>
                    <h2 className={s.quizBlock__title}>{title}</h2>
                    <p className={s.quizBlock__descr}>
                        Ответьте на {questionsCount} {pluralize(questionsCount, 'вопрос', 'вопроса', 'вопросов')},
                        выбрав один из предложенных вариантов. Это отличная возможность закрепить знания, полученные на вебинаре, и проверить, насколько хорошо вы усвоили материал. Удачи!
                    </p>
                    <button
                        disabled={isDisable}
                        className={classNames('button-more', s.quizBlock__btn)}
                        onClick={handleQuizVisible}
                    >
                        {isDisable ? 'Тест пройден' : 'Пройти тест'}
                    </button>
                </div>
                <div className={s.quizBlock__img}>
                    <Image
                        fill
                        src='/assets/img/dna.png'
                        alt=''
                    />
                </div>
            </div>
            {quizVisible && (
                <QuizPopup
                    data={quizData}
                    onClose={handleClose}
                />
            )}
        </section>
    )
}

export default Quiz
